{
  "name": "@michelin/portalfrontend",
  "version": "0.0.1",
  "scripts": {
    "ng": "ng",
    "start": "ng serve --configuration dev",
    "build": "ng build --configuration production",
    "test": "ng test --watch=false --code-coverage",
    "lint": "ng lint",
    "build-compress": "ng build --configuration production && gzipper c ./dist --include js,css,html --output-file-format [filename].[ext] ./dist-compressed/",
    "build:dev": "ng build --configuration indus",
    "build:prod": "ng build --configuration prod",
    "build-compress:prod": "npm run build:prod && gzipper c ./dist --include js,css,html --output-file-format [filename].[ext] ./dist-compressed/",
    "build-compress:dev": "npm run build:dev && gzipper c ./dist --include js,css,html --output-file-format [filename].[ext] ./dist-compressed/"
  },
  "dependencies": {
    "@angular/animations": "^19.0.1",
    "@angular/cdk": "^19.0.1",
    "@angular/common": "^19.0.1",
    "@angular/compiler": "^19.0.1",
    "@angular/core": "^19.0.1",
    "@angular/forms": "^19.0.1",
    "@angular/material": "^19.0.1",
    "@angular/material-moment-adapter": "^19.0.1",
    "@angular/platform-browser": "^19.0.1",
    "@angular/platform-browser-dynamic": "^19.0.1",
    "@angular/router": "^19.0.1",
    "@michelin/around-tire": "^8.1.0",
    "@michelin/charts": "^8.1.0",
    "@michelin/maps": "^8.1.0",
    "@michelin/theme": "^8.1.0",
"@michelin/auth": "^6.0.1","@michelin/observability": "^1.0.2",    "hammerjs": "^2.0.8",
    "moment": "^2.30.1",
    "ngx-pipes": "^3.2.2",
    "overlayscrollbars": "^2.9.2",
    "rxjs": "^7.5.5",
    "tslib": "^2.2.0",
    "zone.js": "^0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^19.0.2",
    "@angular-eslint/builder": "19.8.1",
    "@angular-eslint/eslint-plugin": "19.8.1",
    "@angular-eslint/eslint-plugin-template": "19.8.1",
    "@angular-eslint/schematics": "19.8.1",
    "@angular-eslint/template-parser": "19.8.1",
    "@angular/cli": "^19.0.2",
    "@angular/compiler-cli": "^19.0.1",
    "@types/jasmine": "~4.3.1",
    "@types/jasminewd2": "~2.0.10",
    "@types/node": "^22.10.1",
    "@types/overlayscrollbars": "^1.12.5",
    "@typescript-eslint/eslint-plugin": "5.59.2",
    "@typescript-eslint/parser": "5.59.2",
    "eslint": "^8.57.0",
    "eslint-config-prettier": "^8.10.0",
    "eslint-plugin-import": "^2.29.1",
    "eslint-plugin-jsdoc": "^48.2.1",
    "eslint-plugin-prefer-arrow": "^1.2.3",
    "eslint-plugin-prettier": "^4.2.1",
    "husky": "^7.0.4",
    "jasmine-core": "~4.6.0",
    "jasmine-spec-reporter": "~7.0.0",
    "karma": "^6.4.3",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "^2.1.0",
    "postcss": "^8.4.38",
    "prettier": "^2.8.8",
    "prettier-eslint": "^15.0.1",
    "pretty-quick": "^3.3.1",
    "ts-node": "~10.9.1",
    "typescript": "^5.5.0"
  }
}
